import { IWixCollectionTransformed } from '../../../services/models/types/wixProduct.types';

export const visibilityStatusOptions: IWixCollectionTransformed[] = [
  { id: '', value: 'All status' },
  { id: '1', value: 'Visible' },
  { id: '0', value: 'Invisible' },
];
